<div class="loading">
  <span class="loading-dots">•</span>
</div>
